export const formLabelTheme = {
  baseStyle: {
    marginBottom: '4',
    color: '#4D4D4D',
  },
}
